export enum CampaignVariant {
  A = 'A',
  B = 'B',
  C = 'C',
}

const VALID_RAW = new Set(
  Object.values(CampaignVariant).map((v) => v.toLowerCase()),
);

export function parseCampaignVariant(
  raw: string | undefined | null,
): CampaignVariant | null {
  const lower = raw?.toLowerCase();
  if (lower && VALID_RAW.has(lower)) {
    return lower.toUpperCase() as CampaignVariant;
  }
  return null;
}

export const CAMPAIGN_TAG_CATEGORY = 'kampagne';

export const CAMPAIGN_TAG_VALUES = Object.values(CampaignVariant).map((v) =>
  v.toLowerCase(),
);

/**
 * The variant a Page renders in: the value of its own `kampagne:*` tag, or A
 * for a Page without one — the default location template is untagged and
 * implicitly A. Read off the Page that won Page Selection, never off the
 * visitor's tag bag, so a visitor's `sh_campaign` cookie cannot restyle a Page
 * that has no variant of its own (SH-471).
 */
export function campaignVariantOfPage(
  tags: readonly string[] | undefined,
): CampaignVariant {
  const prefix = `${CAMPAIGN_TAG_CATEGORY}:`;
  const tag = tags?.find((t) => t.startsWith(prefix));
  return parseCampaignVariant(tag?.slice(prefix.length)) ?? CampaignVariant.A;
}
